import { isLocalEnvironment } from "./environment";

export const SUPER_ADMIN_DOMAIN_NAME = "admin";

export function getOrganizationRoute(domainName?: string) {
  return domainName ? `https://app.${domainName}.${import.meta.env.VITE_DOMAIN_NAME}` : "";
}

export function getPrefixRoute() {
  if (isLocalEnvironment()) return `http://localhost:3002`;
  return `https://app.${import.meta.env.VITE_DOMAIN_NAME}`;
}

export function isSuperAdminOrg(domainName?: string) {
  return domainName === SUPER_ADMIN_DOMAIN_NAME;
}
